import menuTypes from '../actions/menu.actions';

const reducer = (state = initialEntries, action) => {

    switch (action.type) {
        case menuTypes.STORE_MENU:
            return {
                ...state,
                menu: action.payload
            }

        case menuTypes.SET_ACTIVE_MENU:
            return {
                ...state,
                activeMenu: {
                    icon: action.payload.icon,
                    nombre: action.payload.name,
                    pageSelected: action.payload.to
                }
            }

        case menuTypes.CLEAR_MENU:
            return {
                menu: []
            }

        default:
            return state;
    }
};

export default reducer;

var initialEntries = {
    activeMenu: {
        icon: 'cilHome',
        nombre: 'Home'
    },
    menu: []
};